<template>
	<div class="menu-module-footer" @click="emitClick">
		<span>{{ $t('enterprise.see-more') }}</span>
		<m-svg-icon name="jiantou1" class="menu-module-footer-icon"></m-svg-icon>
	</div>
</template>

<script setup>
const emit = defineEmits(['click']);
const emitClick = () => {
	emit('click');
};
</script>

<style lang="less" scoped>
.menu-module-footer {
	padding: 0.14rem 0;
	text-align: center;
	font-size: 0;

	span {
		color: #989898;
		text-align: right;
		font-family: 'PingFang SC';
		font-size: 0.12rem;
		font-style: normal;
		font-weight: 400;
		line-height: 140%;
	}
	.menu-module-footer-icon {
		margin-left: 0.04rem;
		color: #989898;
		font-size: 0.12rem;
	}
}
</style>
